import { variables } from '../../../components/variables';
import React from 'react';
import styled from 'styled-components';

type MenuItemProps = {
    children: React.ReactNode;
    selected?: boolean;
    onSelect: () => string;
    url?: string;
};

const Styles = styled.div<{ selected: boolean }>`
    &&& {
        display: flex;
        position: relative;
        padding: 6px 20px;
        background: ${(props) => (props.selected ? variables.colors['road-grey-5-perc'] : 'transparent')};
        color: ${(props) => (props.selected ? variables.colors['road-grey'] : variables.colors['road-grey-090'])};
        text-shadow: ${(props) => (props.selected ? ` 0 0 ${variables.colors['road-grey']} ` : '')};
        font-size: 12px;
        line-height: 15px;
        font-weight: normal;
        cursor: pointer;

        &:hover {
            background: ${variables.colors['road-grey-5-perc']};
            color: ${variables.colors['road-grey']};
            text-shadow: ${`0 0 ${variables.colors['road-grey']}`};
        }

        a {
            width: 100%;
            color: #677498;
            margin: -6px 0;
            padding: 6px 0;
        }
    }
`;

export function MenuItem({ children, selected = false, onSelect, url }: MenuItemProps) {
    return (
        <Styles selected={selected ?? false} onClick={onSelect}>
            {!url && children}
            {url && <a href={url}>{children}</a>}
        </Styles>
    );
}
